import * as React from 'react';

export const Flyer = (props) => (
    <img src={props.children} alt="" style={pickStyle(props.size)} />
)

const pickStyle = (size) => {
    switch(size) {
        case 'small':
            return styles.small
        case 'medium':
            return styles.medium
        case 'large':
            return styles.large
        default:
            return styles.medium
    }
}

const styles = {
    small: {
        width: '200px',
        height: '267px'
    },
    medium: {
        width: '300px',
        height: '400px'
    },
    large: {
        width: '600px',
        height: '800px'
    }
}


// WEBPACK FOOTER //
// ./src/components/marketing/components/Flyer.js